module.exports = __webpack_public_path__ + "img/icon-warning.75f46b80.svg";